const DAppIcon = ({ className }: { className?: string }) => (
	<svg
		class={className}
		fill='currentColor'
		height='16'
		viewBox='0 0 16 16'
		width='16'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M8.07812 11.1445C8.07812 11.2305 8.14453 11.3008 8.22461 11.3008H11.8379C11.918 11.3008 11.9844 11.2305 11.9844 11.1445V10.207C11.9844 10.1211 11.918 10.0508 11.8379 10.0508H8.22461C8.14453 10.0508 8.07812 10.1211 8.07812 10.207V11.1445ZM4.27148 11.2637L8.02148 8.11914C8.0957 8.05664 8.0957 7.94141 8.02148 7.87891L4.27148 4.73633C4.24885 4.71708 4.22116 4.70473 4.19171 4.70074C4.16226 4.69676 4.13229 4.70131 4.10535 4.71385C4.07841 4.7264 4.05564 4.74641 4.03973 4.77151C4.02383 4.79661 4.01546 4.82575 4.01562 4.85547V6.08008C4.01562 6.12695 4.03516 6.16992 4.07227 6.19922L6.2168 8L4.07227 9.80078C4.05481 9.8154 4.04071 9.8336 4.03093 9.85417C4.02116 9.87473 4.01594 9.89716 4.01562 9.91992V11.1445C4.01562 11.2773 4.16992 11.3496 4.27148 11.2637ZM15.1875 0.1875H0.8125C0.466797 0.1875 0.1875 0.466797 0.1875 0.8125V15.1875C0.1875 15.5332 0.466797 15.8125 0.8125 15.8125H15.1875C15.5332 15.8125 15.8125 15.5332 15.8125 15.1875V0.8125C15.8125 0.466797 15.5332 0.1875 15.1875 0.1875ZM14.4062 14.4062H1.59375V1.59375H14.4062V14.4062Z'
			fill='currentColor'
		/>
	</svg>
)

export { DAppIcon }
